<template>
    <draggable v-model="choices" element="ul" class="list-group" :options="{handle:'.handle'}">
        <li class="list-group-item" v-for="(choice,i) in choices" :key="choice.id">
            <div class="input-group">
                <div class="input-group-prepend handle">
                    <div class="input-group-text">
                        <i class="fa fa-fw fa-bars"></i>
                    </div>
                </div>
                <div class="input-group-prepend">
                    <div class="input-group-text">
                        <input type="radio" v-model="correctChoice" :value="i" />
                    </div>
                </div>
                <input type="text" v-model="choice.answer_caption" class="form-control" placeholder="Answer caption text...">
                <input type="text" v-model="choice.answer_caption_fr" class="form-control" placeholder="French translation">
                <div class="input-group-append">
                    <button type="button" class="btn btn-default" @click="remove(choice,i)"><i class="fa fa-fw fa-close"></i> Remove</button>
                </div>
            </div>
        </li>
        <li slot="footer" class="list-group-item p-0">
            <div class="text-center m-3" v-if="choices.length">
                <label class="m-0">
                    <input type="radio" v-model="correctChoice" value="-1" />
                    There is no correct answer and multiple answers are allowed
                </label>
            </div>
            <div class="text-center m-3">
                <button type="button" class="btn btn-default" @click="add"><i class="fa fa-fw fa-plus"></i> Add</button>
            </div>
            <input v-if="correctChoice!==null" type="hidden" name="correct_answer" v-model="correctChoice" />
            <template v-for="(choice,i) in choices">
                <input type="hidden" :name="'surveyQuestionChoices['+i+'][id]'" v-model="choice.id" />
                <input type="hidden" :name="'surveyQuestionChoices['+i+'][answer_caption]'" v-model="choice.answer_caption" />
                <input type="hidden" :name="'surveyQuestionChoices['+i+'][answer_caption_fr]'" v-model="choice.answer_caption_fr" />
                <input v-if="choice.deleted" type="hidden" :name="'surveyQuestionChoices['+i+'][deleted]'" value="1" />
            </template>
            <template v-for="choiceId in choicesToDelete">
                <input type="hidden" :name="'surveyQuestionChoices:deleted[]'" :value="choiceId" />
            </template>
        </li>
    </draggable>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        components: {
            draggable
        },

        props: {
            data: {
                type: Object,
                default: null
            },
        },

        data:()=>({
            choices: [],
            choicesToDelete: [],
            correctChoice: null
        }),

        methods: {
            add() {
                this.choices.push({
                    id: null,
                    answer_caption: '',
                    answer_caption_fr: ''
                })
            },
            remove(choice, index) {
                this.choices.splice(index, 1);
                if (choice.id) {
                    this.choicesToDelete.push(choice.id);
                }
                if (this.correctChoice === index) {
                    this.correctChoice = null;
                }
                else if (this.correctChoice > index) {
                    this.correctChoice--;
                }
            }
        },

        created() {
            if (this.data) {
                this.choices = this.data.surveyQuestionChoices;
                this.choicesToDelete = this.data['surveyQuestionChoices:deleted'];
                this.correctChoice = this.data.correct_answer;
            }
            console.log(this.data);
            console.log(this.choicesToDelete);
        }
    }
</script>

<style scoped>

</style>